import {
  CONTRACTOR_CONFIRM_DATA,
  SEND_DATA,
  ATTENTED_DOCS,
} from '@/store/modules/temporarily/types';

export default {
  contractorConfirmData: state => state[CONTRACTOR_CONFIRM_DATA],
  sendData: state => state[SEND_DATA],
  attentedDocs: state => state[ATTENTED_DOCS],
};
